// INGRESOS
export { IngresosBodega } from "./pages/Ingresos/IngresosBodega";
export { RecepcionIngreso } from "./pages/Ingresos/RecepcionIngreso";

// SALIDAS
export { HistorialSalidas } from "./pages/Salidas/HistorialSalidas";
export { CreacionSalida } from "./pages/Salidas/CreacionSalida";
export { BoletaSalida } from "./pages/Salidas/BoletaSalida";

// CONTROL DE CALIDAD
export { HistorialTraslados as HistorialControlCalidad } from "./pages/ControlCalidad/HistorialTraslados";
export { CreacionTraslado as CreacionControlCalidad } from "./pages/ControlCalidad/CreacionTraslado";
export { BoletaTraslado as BoletaControlCalidad } from "./pages/ControlCalidad/BoletaTraslado";

// INVENTARIOS
export { InventarioBodega } from "./pages/Inventarios/InventarioBodega";
export { CreacionCierre } from "./pages/Inventarios/CierresInventario/CreacionCierre";
export { DetalleCierre } from "./pages/Inventarios/CierresInventario/DetalleCierre";
export { ReajustePacas } from "./pages/Inventarios/CierresInventario/ReajustePacas";
export { PacasAlCorte } from "./pages/Inventarios/CierresInventario/PacasAlCorte";
